import React from "react";
import Header from "./Header";
import { MdWavingHand } from "react-icons/md";
import "../assets/css/Toolbox.css";
import bootstrap from "../assets/images/bootstrap.svg";
import js from "../assets/images/js.svg";
import firebase from "../assets/images/firebase.svg";
import react from "../assets/images/react.svg";
import sass from "../assets/images/sass.svg";
import figma from "../assets/images/figma.svg";
import typescript from "../assets/images/typescript.svg";
import sanity from "../assets/images/sanity.svg";
import nextjs from "../assets/images/nextjs.svg";

const Toolbox = () => {
  return (
    <>
      <Header />
      <div className="welcome-container">
        <MdWavingHand className="ikon" />
        <h3 className="welcome">
          Hi! My name is Metehan.
          <p className="top">
            I'm a front-end developer specializing in
            <span className="design" style={{ marginLeft: "5px" }}>
              ReactJs
            </span>
          </p>
        </h3>
      </div>
    </>
  );
};

export default Toolbox;
